import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  trigger: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: designTokens.spacing[2],
    width: "148px",
    padding: `6px ${designTokens.spacing[3]}`,
    fontFamily: "inherit",
    fontSize: designTokens.fontSize.sm,
    color: designTokens.neutral[900],
    backgroundColor: designTokens.neutral.white,
    border: `1px solid ${designTokens.neutral[300]}`,
    borderRadius: designTokens.borderRadius.sm,
    cursor: "pointer",
    transition: `border-color ${designTokens.transition.fast}`,
    ":hover": {
      border: `1px solid ${designTokens.neutral[500]}`,
    },
    ":focus-visible": {
      outline: `2px solid ${designTokens.accent[500]}`,
      outlineOffset: "2px",
    },
    ":disabled": {
      cursor: "not-allowed",
      color: designTokens.neutral[400],
      backgroundColor: designTokens.neutral[100],
    },
  },
  surface: {
    // Popover default padding is removed so the calendar and footer sit flush;
    // the footer supplies its own padding and separator.
    padding: "0",
  },
  triggerIcon: {
    color: designTokens.neutral[500],
    flexShrink: "0",
  },
});
